import { TmcService } from '../services/tmc.service'
import {
    AcceptAdmissionPayload,
    AcceptRelocationPayload,
    DownloadRemainsPayloadT,
    DownloadRemainsResponseT,
    DownloadTmcPayloadT,
    DownloadTmcResponseT,
    OrdersDownloadAdmissionsPayloadT,
    OrdersDownloadAdmissionsResponseT,
    OrdersDownloadRelocationsPayloadT,
    OrdersDownloadRelocationsResponseT,
    OrdersDownloadWriteoffsPayloadT,
    OrdersDownloadWriteoffsResponseT,
    RemainsGetListParamsT,
    TmcCreateAdmissionPayload,
    TmcCreatePayload,
    TmcCreateRelocationPayload,
    TmcGetAdmissionResponseT,
    TmcGetAdmissionsListParams,
    TmcGetAdmissionsListResponseT,
    TmcGetListParams,
    TmcGetListResponseT,
    TmcGetRelocationListResponseT,
    TmcGetRelocationResponseT,
    TmcGetRelocationsListParams,
    TmcGetRemainsListResponseT,
    TmcGetUnitsListResponseT,
    TmcGetWriteoffResponseT,
    TmcGetWriteoffsResponseT,
    TmcSecondaryMaterialPayload,
    WriteOffsGetListParams,
    WriteoffPayloadI,
    WriteoffUpdatePayloadI,
} from '../types/tmc.types'

const tmcService = new TmcService()

class TMC {
    getList(
        page: number,
        search?: string | null,
        params?: TmcGetListParams
    ): Promise<TmcGetListResponseT> {
        return tmcService.getList(page, search, params)
    }

    createTMC(payload: TmcCreatePayload): Promise<void> {
        return tmcService.createTMC(payload)
    }

    getAdmissionsList(params: TmcGetAdmissionsListParams): Promise<TmcGetAdmissionsListResponseT> {
        return tmcService.getAdmissionsList(params)
    }

    getAdmission(admission_id: number): Promise<TmcGetAdmissionResponseT> {
        return tmcService.getAdmission(admission_id)
    }

    createAdmission(payload: TmcCreateAdmissionPayload): Promise<void> {
        return tmcService.createAdmission(payload)
    }

    createSecondaryMaterial(payload: TmcSecondaryMaterialPayload): Promise<void> {
        return tmcService.createSecondaryMaterial(payload)
    }

    updateAdmission(admission_id: number, payload: TmcCreateAdmissionPayload): Promise<void> {
        return tmcService.updateAdmission(admission_id, payload)
    }

    updateAdmissionSecondary(
        admission_id: number,
        payload: TmcSecondaryMaterialPayload
    ): Promise<void> {
        return tmcService.updateAdmissionSecondary(admission_id, payload)
    }

    completeAdmission(receipt_id: number, payload: AcceptAdmissionPayload): Promise<void> {
        return tmcService.completeAdmission(receipt_id, payload)
    }

    async cancelAdmission(receipt_id: number): Promise<void> {
        return tmcService.cancelAdmission(receipt_id)
    }

    getRelocationList(params: TmcGetRelocationsListParams): Promise<TmcGetRelocationListResponseT> {
        return tmcService.getRelocationList(params)
    }

    getRelocation(relocation_id: number): Promise<TmcGetRelocationResponseT> {
        return tmcService.getRelocation(relocation_id)
    }

    createRelocation(payload: TmcCreateRelocationPayload): Promise<void> {
        return tmcService.createRelocation(payload)
    }

    updateRelocation(relocation_id: number, payload: TmcCreateRelocationPayload): Promise<void> {
        return tmcService.updateRelocation(relocation_id, payload)
    }

    completeRelocation(relocation_id: number, payload: AcceptRelocationPayload): Promise<void> {
        return tmcService.completeRelocation(relocation_id, payload)
    }

    cancelRelocation(relocation_id: number): Promise<void> {
        return tmcService.cancelRelocation(relocation_id)
    }

    cancelWriteOff(id: number): Promise<void> {
        return tmcService.cancelWriteOff(id)
    }

    getUnitsList(page: number, search?: string): Promise<TmcGetUnitsListResponseT> {
        return tmcService.getUnitsList(page, search)
    }

    getRemainsList(params: RemainsGetListParamsT): Promise<TmcGetRemainsListResponseT> {
        return tmcService.getRemainsList(params)
    }

    writeOff(payload: FormData): Promise<void> {
        return tmcService.writeOff(payload)
    }

    updateWriteOff(writeoff_id: number, payload: FormData): Promise<void> {
        return tmcService.updateWriteOff(writeoff_id, payload)
    }

    getWriteOffs(params: WriteOffsGetListParams): Promise<TmcGetWriteoffsResponseT> {
        return tmcService.getWriteOffs(params)
    }

    getWriteOff(writeoff_id: number): Promise<TmcGetWriteoffResponseT> {
        return tmcService.getWriteOff(writeoff_id)
    }

    deleteReceiptItem(receipt_item_id: number): Promise<void> {
        return tmcService.deleteReceiptItem(receipt_item_id)
    }

    deletePackageFile(id: number): Promise<void> {
        return tmcService.deletePackageFile(id)
    }

    deleteDirectionItem(direction_item_id: number): Promise<void> {
        return tmcService.deleteDirectionItem(direction_item_id)
    }

    deleteWriteoffItem(writeoff_item_id: number): Promise<void> {
        return tmcService.deleteWriteoffItem(writeoff_item_id)
    }

    exportExcelAdmissions(
        params: OrdersDownloadAdmissionsPayloadT
    ): Promise<OrdersDownloadAdmissionsResponseT> {
        return tmcService.exportExcelAdmissions(params)
    }

    exportExcelRemains(params: DownloadRemainsPayloadT): Promise<DownloadRemainsResponseT> {
        return tmcService.exportExcelRemains(params)
    }

    exportExcelTmc(params: DownloadTmcPayloadT): Promise<DownloadTmcResponseT> {
        return tmcService.exportExcelTmc(params)
    }

    exportExcelRelocations(
        params: OrdersDownloadRelocationsPayloadT
    ): Promise<OrdersDownloadRelocationsResponseT> {
        return tmcService.exportExcelRelocations(params)
    }

    exportExcelWriteoffs(
        params: OrdersDownloadWriteoffsPayloadT
    ): Promise<OrdersDownloadWriteoffsResponseT> {
        return tmcService.exportExcelWriteoffs(params)
    }

    importInvoices(form_data: FormData): Promise<void> {
        return tmcService.importInvoices(form_data)
    }
}

export const tmc = new TMC()
